import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ISSUANCE_INVESTOR } from '../models/issuance';
import { VW_SERIES_SA } from '../models/seriessa';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import * as Globals from '../globals';
declare var $: any;
const url = Globals.serviceUrl;

@Component({
  selector: 'app-issuance',
  templateUrl: './issuance.component.html',
  styleUrls: ['./issuance.component.css']
})
export class IssuanceComponent implements OnInit {

  idtyNo: string;
  invId: number;
  issuances: ISSUANCE_INVESTOR[];
  dataIssuances: ISSUANCE_INVESTOR[];
  tab: number = 1;
  param: any;
  search: string = '';
  priority: string = '';
  paId: number = 0;
  loading: boolean;
  seriesId: number;
  totBids: number = 0;
  totAlts: number = 0;
  paramSeries: any = { OPEN: false };
  urlFile = Globals.archiveUrl + 'bids?code=';
  series: any[];
  p: number = 1;
  userProfile: any;
  authMenu: any;
  colSort: string[] = ['BID_DATE'];
  reverse: boolean = true;
  col: number = 5;
  rptType: number = 1;
  checkItems: number = 0;
  checked: boolean;
  cds:any[];
  seriessa:VW_SERIES_SA[];
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/pemesanan/issuance/0') {
          this.tab = 1;
          this.router.navigate(['/pemesanan/issuance/1']);
        }
      };
    });
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/pemesanan/issuance/1']);
    }
    this.issuances = [];
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      if (this.userProfile.PARENT_GROUP_ID == 5) {
        this.authMenu = Globals.getAuthMenu(203, this.userProfile);
      }
      if (this.userProfile.PARENT_GROUP_ID == 4) {
        this.authMenu = Globals.getAuthMenu(204, this.userProfile);
      }
    }
  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['INV_ID'];
        break;
      case 2:
        this.colSort = ['INV_NAME'];
        break;
      case 3:
        this.colSort = ['BID_ID'];
        break;
      case 4:
        this.colSort = ['ALT_AMT'];
        break;
      case 5:
        this.colSort = ['BID_DATE'];
        break;
      case 6:
        this.colSort = ['BID_AMT'];
        break;
      case 7:
        this.colSort = ['SELLING_AGENT'];
        break;
      case 8:
        this.colSort = ['STAT_ISSUE'];
        break;
      default:
        break;
    }
  }
  seriesChanged(ev: any) {
    this.seriesId = ev.target.value;
    this.getIssues();
    for (var i = 0; i < this.series.length; i++) {
      if (this.seriesId == this.series[i].SERIES_ID) {
        this.paramSeries = this.series[i];
        break;
      }
    }
  }
  priorityChanged(ev: any) {
    if (ev == 0){
      this.priority = null;
    }
    else  {
      this.priority = ev.target.value;
    }
    this.getIssues();
  }

  paIdChanged(ev: any) {
    this.paId = ev.target.value;
    this.getIssues();
  }

  getIssues() {
    this.loading = true;
    this.http.get(url + 'ritel/issuances?seriesId=' + this.seriesId + '&search=' + this.search + '&priority=' + this.priority + '&paId=' + this.paId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.issuances = res.json();
        this.totBids = 0;
        this.totAlts = 0;
        for (var i = 0; i < this.issuances.length; i++) {
          this.totBids += this.issuances[i].BID_AMT;
          this.totAlts += this.issuances[i].ALT_AMT;
        }
        /*if (!this.paramSeries.OPEN) {
          this.toastr.warning('Masa penawaran telah berakhir');
        }*/
        this.getCds(33);
        this.getSeriesSa();      
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/issueactive?cdOnline=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId == this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              break;
            }
          }
          this.getIssues();
        } else if (this.series.length == 0) {
          //this.toastr.warning('Masa penawaran telah berakhir');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getSeriesSa() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriessa?seriesId=' + this.seriesId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seriessa = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getCds(cgNo: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=' + cgNo + '&t' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.cds = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  generateReport(format: string) {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",rpttype:' + this.rptType + '}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'Rpt1901?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }
  downloadCSV() {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSVI?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }
  setCheck(val: boolean) {
    for (var i = 0; i < this.issuances.length; i++) {
      if (this.issuances[i].ATTACHMENT && this.issuances[i].STAT_ISSUE == '0') {
        this.issuances[i].CHECKED = val;
        if (val) {
          this.checkItems++;
        } else {
          this.checkItems = 0;
        }

      }
    }
  }
  getCheckItems() {
    this.checked = false;
    this.checkItems = 0;
    for (var i = 0; i < this.issuances.length; i++) {
      if (this.issuances[i].CHECKED) {
        this.checkItems++;
      }
    }
  }

  setConfirm(val: any) {
    this.dataIssuances = [];
    for (var i = 0; i < this.issuances.length; i++) {
      if (this.issuances[i].CHECKED) {
        this.issuances[i].STAT_ISSUE = val;
        this.dataIssuances.push(this.issuances[i]);
      }
    }
    if (this.dataIssuances.length > 0) {
      this.http.put(Globals.serviceUrl + 'ritel/confirmIssueBids?id=' + this.userProfile.USER_ID, this.dataIssuances, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.checkItems = 0;
          this.checked = false;
          this.getIssues();
          this.toastr.success('Data berhasil disimpan');
          this.loading = false;
        }, err => {
          if(err.status == 400){
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.getIssues();
           }
          if(err.status == 422){
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            $('#confirm').modal('show');
          }
          //$('#confirm').modal('show');
          // $('#modal').modal('hide');
          this.loading = false;
        });
    }
  }

  setConfirmNp(val: any) {
    this.dataIssuances = [];
    for (var i = 0; i < this.issuances.length; i++) {
      if (this.issuances[i].CHECKED) {
        this.issuances[i].STAT_ISSUE = val;
        this.dataIssuances.push(this.issuances[i]);
      }
    }
    if (this.dataIssuances.length > 0) {
      this.http.put(Globals.serviceUrl + 'ritel/confirmIssueBidsNp?id=' + this.userProfile.USER_ID, this.dataIssuances, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.checkItems = 0;
          this.checked = false;
          $('#confirm').modal('hide');
          this.toastr.success('Data berhasil disimpan');
          this.loading = false;
          this.getIssues();
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          $('#confirm').modal('hide');
          this.loading = false;
          this.getIssues();
        });
    }
  }

  scroll (){
    $('.pane-hScroll').scroll(function() {
      $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
    });
    }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/issuance/issuance.component.ts